import { Box, Button, Typography } from "@strapi/design-system"
import { Plus } from "@strapi/icons"

interface EmptyListProps {
  text: string
  addText: string
  onClick: () => void
  showAdd: boolean
}

const EmptyList = ({ text, addText, onClick, showAdd }: EmptyListProps) => (
  <Box
    background="neutral100"
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "20px",
    }}
  >
    <Typography
      type="pi"
      style={{
        color: "#A5A6B8",
        fontWeight: "400",
        fontSize: ".875rem",
        lineHeight: "1.25rem",
        maxWidth: "500px",
        textAlign: "center",
      }}
    >
      {text}
    </Typography>

    {showAdd ? (
      <Button disabled={false} startIcon={<Plus />} onClick={onClick}>
        {addText}
      </Button>
    ) : null}
  </Box>
)

export default EmptyList
